import React, { useState } from 'react';
import { Modal, FormGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Loader from '../Utility/Loader/Loader';
import CustomTooltip from '../Tooltip/CustomTooltip';

function SetComponentType({ onOpen, onSubmit, toggle, title, loading, bomTypeId, loggedInUserId, forComposition, label }) {
  const [isDesabled, setIsDesabled] = useState(false);
  const { t } = useTranslation('common');
  const [componentTypeList, setComponentTypeList] = useState([
    {
      name: '',
      isEmpty: false,
      isActive: true,
      isNew: true,
      _id: '',
    },
  ]);

  const handleAdded = async () => {
    const dataObj = [
      ...componentTypeList,
      {
        name: '',
        isEmpty: false,
        isActive: true,
        isNew: true,
        _id: '',
      },
    ];
    setComponentTypeList(dataObj);
  };

  const handleRemove = (index) => {
    let rows = [...componentTypeList];
    rows.splice(index, 1);
    if (rows.length === 0) {
      rows = [
        {
          name: '',
          isEmpty: false,
          isActive: true,
          isNew: true,
          _id: '',
        },
      ];
    }
    setComponentTypeList(rows);
  };

  const handleChange = (event, index) => {
    const fieldName = event?.currentTarget?.name || '';
    const value = event?.currentTarget?.value?.trimStart() || '';

    if (value.length < 50) {
      const rows = [...componentTypeList];
      let duplicateFound = false;

      rows.forEach((item, idx) => {
        if (idx !== index && item.name.toLowerCase().trim() === value.toLowerCase().trim()) {
          duplicateFound = true;
        }
      });

      if (duplicateFound) {
        const updatedRows = rows.map((item, idx) => {
          if (idx === index) {
            return {
              ...item,
              [fieldName]: value,
              isEmpty: value === '',
              isDuplicate: true, // Flag to indicate duplicate entry
            };
          }
          return item;
        });
        setComponentTypeList(updatedRows);
      } else {
        const updatedRows = rows.map((item, idx) => {
          if (idx === index) {
            return {
              ...item,
              [fieldName]: value,
              isEmpty: value === '',
              isDuplicate: false, // Reset the flag if not a duplicate
            };
          }
          return item;
        });
        setComponentTypeList(updatedRows);
      }
    }
  };

  const saveComponentList = async () => {
    setIsDesabled(true);
    if (componentTypeList?.length > 0) {
      const hasDuplicate = componentTypeList?.some((item) => item?.isDuplicate);

      if (!hasDuplicate) {
        const emptyField = componentTypeList.filter((item) => item.name.trim() === '');

        if (emptyField.length === 0) {
          const data = componentTypeList.map((ele) => ({ ...ele, name: ele.name.trim() }));
          if (forComposition) {
            const obj = {
              names: JSON.stringify(data),
              bomTypeId,
              loggedInUserId,
              title: t('SET_COMPONENET_TYPE.MATERIAL_COMPOSITION_COMPONENET'),
              fromBom: true,
            };
            if (data.length) {
              onSubmit(obj);
            }
          } else {
            const obj = {
              bomSubTypes: JSON.stringify(data),
              bomTypeId,
              loggedInUserId,
            };
            if (data.length) {
              onSubmit(obj);
            }
          }
        } else {
          const newState = componentTypeList.map((obj) => (obj.isEmpty === false && obj.name.trim() === '' ? { ...obj, isEmpty: true } : obj));
          setComponentTypeList(newState);
        }
      }
    }
    setIsDesabled(false);
  };

  return (
    <Modal
      show={onOpen}
      backdrop="static"
      className="common-custom-modal common-new-modal modal-medium"
      aria-labelledby="contained-modal-title-vcenter"
      onHide={toggle}
    >
      <Modal.Header className="modal-header-custom">
        <Modal.Title id="contained-modal-title-vcenter">
          <span>{title}</span>
        </Modal.Title>
        <span onClick={toggle} className="icon-close header-close cursor-pointer ml-auto" />
      </Modal.Header>
      <Modal.Body className="bom-type-body">
        {loading && <Loader />}
        {!loading && (
          <div className="modal-body-content">
            {componentTypeList?.length > 0
              ? componentTypeList.map((item, i) => {
                  return (
                    <div key={i} className="mb-3">
                      <div className="d-flex w-100 align-items-end">
                        <FormGroup className="mb-0">
                          <div className="common-input-control mb-0">
                            <p className="field-name text-bold">
                              {forComposition ? t('SET_COMPONENET_TYPE.COMPOSITION') : label}
                              <span className="asterisk ">*</span>
                            </p>
                            <input
                              type="text"
                              name="name"
                              value={item.name ? item.name : ''}
                              onChange={(e) => handleChange(e, i)}
                              placeholder={forComposition ? t('SET_COMPONENET_TYPE.MODAL_TITLE') : label}
                              className="form-control set-component-form"
                            />
                          </div>
                        </FormGroup>

                        {componentTypeList.length === i + 1 && (
                          <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.ADD')}>
                            <button
                              href={() => false}
                              onClick={() => {
                                handleAdded();
                              }}
                              type="button"
                              aria-label="add"
                              className="btn common-border-button"
                            >
                              <i className="icon-Add text-grey f-18" />
                            </button>
                          </CustomTooltip>
                        )}
                        <CustomTooltip placement="top" tooltipText={t('COMMON_LABEL.DELETE')}>
                          <button
                            onClick={() => {
                              handleRemove(i);
                            }}
                            type="button"
                            aria-label="delete"
                            className="btn common-border-button"
                          >
                            <i className="icon-Delete text-grey f-18" />
                          </button>
                        </CustomTooltip>
                      </div>
                      {item?.isDuplicate && <span className="text-danger f-14 m-0 pl-0 p-1">{t('SET_COMPONENET_TYPE.ENTRY_ALREADY_EXISTS')}</span>}{' '}
                      {item?.isEmpty && (
                        <span className="text-danger f-14 m-0 pl-0 m-0 p-1">
                          {' '}
                          {forComposition ? t('SET_COMPONENET_TYPE.COMPOSITION_REQUIRED') : `${label} is required`}
                        </span>
                      )}
                    </div>
                  );
                })
              : null}
            <div className="modal-buttons set-component-footer d-flex justify-content-end">
              <button
                type="button"
                aria-label="save"
                onClick={() => {
                  saveComponentList();
                }}
                className={isDesabled ? 'btn btn-default disabled' : 'btn save-bom-configure'}
              >
                <i className="icon-Tick-1 f-24" />
              </button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default SetComponentType;
